import BridgeOfficer from "./BridgeOfficer/BridgeOfficer";
import { useEffect, useState } from "react";
import { Pin, PinAngleFill } from "react-bootstrap-icons";
import { factionIcons, tiers } from "../data";
import Ability from "./Ability";
import Price from "./Price";

const styles = {
    factionIndicator: {
        position: "absolute",
        height: "2rem",
        width: "2rem",
        border: "1px solid rgba(0, 0, 0, 0.75)",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        borderTopWidth: "0px",
        borderRightWidth: "0px",
        borderTopRightRadius: "var(--bs-border-radius)",
        borderBottomLeftRadius: "var(--bs-border-radius-lg)",
        padding: ".25rem",
        right: "0",
    },
    bridgeOfficer: {
        height: "auto",
        width: "1.25rem",
    },
    shipImg: {
        height: "256px",
        width: "100%",
        borderBottomLeftRadius: "0",
        borderBottomRightRadius: "0",
    },
};

function Ship({ ship, averages, data, setData }) {
    const [isPinned, setPinned] = useState(
        data.pinned && data.pinned.includes(ship.id)
    );

    const options = { year: "numeric", month: "numeric", day: "numeric" };
    const releasedDate = new Date(ship.released).toLocaleDateString(
        navigator.language,
        options
    );

    const backgroundImg = "url(https://stowiki.net/wiki/Special:Redirect/file/" +
        ship.img_url.replace(/ /, "_").replace("'", "%27") + ")"
    // const backgroundImg = "url(https://stowiki.net/wiki/Special:FilePath/" +
    //     ship.img_url.replace(/ /, "_").replace("'", "%27") + ")"

    const getPercentage = function (stat, average) {
        let diff = stat - average;
        let percent = Math.round((diff / average) * 100 * 10) / 10;

        percent = percent > 0 ? "+" + percent : percent;

        return percent;
    };

    const togglePinned = (shipId) => {
        let newData = { ...data };

        if (!newData.pinned) {
            newData.pinned = [];
        }

        if (newData.pinned.includes(shipId)) {
            const index = newData.pinned.indexOf(shipId);
            newData.pinned.splice(index, 1);

            setData(newData);
        } else {
            setData({
                ...newData,
                pinned: [...newData.pinned, shipId],
            });
        }
    };

    useEffect(() => {
        if (data.pinned && data.pinned.includes(ship.id)) {
            setPinned(true);
        } else {
            setPinned(false);
        }
    }, [data, ship]);

    return (
        <div className="col-12 col-md-6 col-lg-4 col-xl-3">
            <div className="card col my-3 shadow" data-id={ship.id}>
                <div className="position-relative">
                    {factionIcons.hasOwnProperty(ship.faction) && (
                        <div style={styles.factionIndicator}>
                            <img
                                src={"/img/" + factionIcons[ship.faction]}
                                className="d-block m-auto"
                                alt={ship.faction + " Faction"}
                                height="24"
                            />
                        </div>
                    )}
                    <div
                        style={{
                            ...styles.shipImg,
                            backgroundImage: backgroundImg
                        }}
                        className="card-img border-bottom border-primary"
                    ></div>
                    <div className="card-img-overlay">
                        {ship.display_class ? (
                            <>
                                <h5
                                    className="card-title"
                                    style={{ marginRight: ".5rem" }}
                                >
                                    {ship.display_prefix
                                        ? ship.display_prefix + " "
                                        : ""}
                                    <em>{ship.display_class}</em> Class
                                </h5>
                                <h5 className="card-subtitle">
                                    {ship.display_type}
                                </h5>
                            </>
                        ) : (
                            <h5 className="card-title mr-1">{ship.name}</h5>
                        )}
                    </div>
                </div>
                <div className="card-body p-0">
                    <div className="row g-0 lh-1">
                        <div className="col-7 border-end border-primary">
                            <small className="text-muted fw-light p-1 lh-sm">
                                Type
                            </small>
                            <div
                                className="text-center p-1 text-nowrap"
                                title={ship.type.join(" / ")}
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {ship.type.join(" / ")}
                            </div>
                        </div>
                        <div className="col-2 border-end border-primary">
                            <small className="text-muted fw-light p-1 lh-sm">
                                Tier
                            </small>
                            <div className="text-center p-1">
                                {tiers[ship.tier]}
                            </div>
                        </div>
                        <div className="col-3">
                            <small className="text-muted fw-light p-1 lh-sm">
                                Released
                            </small>
                            <div className="text-center p-1">
                                {releasedDate}
                            </div>
                        </div>
                    </div>
                    <div className="row g-0 border-top border-primary lh-1">
                        <div className="col border-end border-primary">
                            <small className="text-muted fw-light p-1 lh-sm">
                                Weapons
                            </small>
                            <div className="p-1 text-center">
                                <span title="Fore Weapons">
                                    {ship.fore_weapons}
                                    <img
                                        className="me-1"
                                        src="/img/Arc_fore_icon.png"
                                        alt="Fore Weapon Slots"
                                    />
                                </span>
                                <span title="Aft Weapons">
                                    {ship.aft_weapons}
                                    <img
                                        src="/img/Arc_aft_icon.png"
                                        alt="Aft Weapon Slots"
                                    />
                                </span>
                            </div>
                        </div>
                        {ship.can_dual_cannons !== 0 && (
                            <div className="col border-end border-primary">
                                <small className="text-muted fw-light p-1">
                                    Dual Cannons
                                </small>
                                <div className="text-center p-1">
                                    {ship.can_dual_cannons
                                        ? "✅"
                                        : "❌"}
                                </div>
                            </div>
                        )}
                        {ship.can_experimental_weapon !== 0 && (
                            <div className="col border-end border-primary">
                                <small className="text-muted fw-light p-1">
                                    Exp. Weapon
                                </small>
                                <div className="text-center p-1">
                                    {ship.can_experimental_weapon
                                        ? "✅"
                                        : "❌"}
                                </div>
                            </div>
                        )}
                        {ship.can_secondary_deflector !== 0 && (
                            <div className="col border-end border-primary">
                                <small className="text-muted fw-light p-1">
                                    Sec. Deflector
                                </small>
                                <div className="text-center p-1">
                                    {ship.can_secondary_deflector
                                        ? "✅"
                                        : "❌"}
                                </div>
                            </div>
                        )}
                        <div className="col">
                            <small className="text-muted fw-light p-1 lh-sm">
                                Device Slots
                            </small>
                            <div className="text-center p-1">
                                <div
                                    className="text-center d-flex justify-content-around"
                                    title="Device slots"
                                >
                                    <div>{ship.device_slots}</div>
                                    <div
                                        className={
                                            getPercentage(
                                                ship.device_slots,
                                                averages.device_slots
                                            ) > 0
                                                ? "text-success"
                                                : "text-danger"
                                        }
                                    >
                                        {getPercentage(
                                            ship.device_slots,
                                            averages.device_slots
                                        )}
                                        %
                                    </div>
                                </div>
                            </div>
                        </div>
                        {ship.hangar_bays > 0 && (
                            <div className="col border-start border-primary">
                                <small className="text-muted fw-light p-1 lh-sm">
                                    Hangar Bays
                                </small>
                                <div className="text-center">
                                    {ship.hangar_bays && (
                                        <div
                                            className="text-center p-1"
                                            title="Hangar Bays"
                                        >
                                            {ship.hangar_bays}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="row g-0 border-top border-primary lh-1">
                        <div className="col border-end border-primary">
                            <small className="text-muted fw-light p-1 lh-1">
                                Hull Modifier
                            </small>
                            <div className="text-center p-1 d-flex justify-content-around">
                                <div>{ship.hull_modifier}</div>
                                {ship.hull_modifier && (
                                    <div
                                        className={
                                            getPercentage(
                                                ship.hull_modifier,
                                                averages.hull_modifier
                                            ) > 0
                                                ? "text-success"
                                                : "text-danger"
                                        }
                                    >
                                        {getPercentage(
                                            ship.hull_modifier,
                                            averages.hull_modifier
                                        )}
                                        %
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col border-end border-primary">
                            <small className="text-muted p-1 fw-light lh-1">
                                Hull
                            </small>
                            <div className="text-center p-1 d-flex justify-content-around">
                                <div>
                                    {parseInt(ship.hull).toLocaleString()}
                                </div>
                                <div
                                    className={
                                        getPercentage(
                                            ship.hull,
                                            averages.hull
                                        ) > 0
                                            ? "text-success"
                                            : "text-danger"
                                    }
                                >
                                    {getPercentage(ship.hull, averages.hull)}%
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <small className="text-muted p-1 fw-light lh-1">
                                Shield Modifier
                            </small>
                            <div className="text-center p-1 d-flex justify-content-around">
                                <div>{ship.shield_modifier}</div>
                                <div
                                    className={
                                        getPercentage(
                                            ship.shield_modifier,
                                            averages.shield_modifier
                                        ) > 0
                                            ? "text-success"
                                            : "text-danger"
                                    }
                                >
                                    {getPercentage(
                                        ship.shield_modifier,
                                        averages.shield_modifier
                                    )}
                                    %
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-0 border-top border-primary lh-1">
                        <div className="col border-end border-primary">
                            <small className="text-muted fw-light p-1">
                                Turn Rate
                            </small>
                            <div className="text-center p-1 d-flex justify-content-around">
                                <div>{ship.turn_rate}</div>
                                {ship.hull_modifier && (
                                    <div
                                        className={
                                            getPercentage(
                                                ship.turn_rate,
                                                averages.turn_rate
                                            ) > 0
                                                ? "text-success"
                                                : "text-danger"
                                        }
                                    >
                                        {getPercentage(
                                            ship.turn_rate,
                                            averages.turn_rate
                                        )}
                                        %
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col border-end border-primary">
                            <small className="text-muted p-1 fw-light">
                                Impulse Modifier
                            </small>
                            <div className="text-center p-1 d-flex justify-content-around">
                                <div>{ship.impulse_modifier}</div>
                                <div
                                    className={
                                        getPercentage(
                                            ship.impulse_modifier,
                                            averages.impulse_modifier
                                        ) > 0
                                            ? "text-success"
                                            : "text-danger"
                                    }
                                >
                                    {getPercentage(
                                        ship.impulse_modifier,
                                        averages.impulse_modifier
                                    )}
                                    %
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <small className="text-muted p-1 fw-light">
                                Intertia Rating
                            </small>
                            <div className="text-center p-1 d-flex justify-content-around">
                                <div>{ship.inertia_rating}</div>
                                <div
                                    className={
                                        getPercentage(
                                            ship.inertia_rating,
                                            averages.inertia_rating
                                        ) > 0
                                            ? "text-danger"
                                            : "text-success"
                                    }
                                >
                                    {getPercentage(
                                        ship.inertia_rating,
                                        averages.inertia_rating
                                    )}
                                    %
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="border-top border-primary d-flex">
                        <div className="flex-fill">
                            <small className="text-muted p-1 fw-light lh-1">
                                Abilities
                            </small>

                            <div className="p-1 text-center abilities-list">
                                {ship.abilities &&
                                    ship.abilities.map((ability, index) => (
                                        <Ability
                                            key={index}
                                            ability={ability}
                                            faction={ship.faction}
                                        />
                                    ))}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex border-top border-primary g-0">
                        <div className="border-end border-primary flex-fill">
                            <small className="text-muted p-1 fw-light lh-1">
                                Bridge Officers
                            </small>
                            <div className="p-1 text-center boff-list">
                                {ship.bridge_officers &&
                                    ship.bridge_officers.map(
                                        (bridgeOfficer) => (
                                            <BridgeOfficer
                                                key={bridgeOfficer.id}
                                                bridgeOfficer={bridgeOfficer}
                                                style={styles.bridgeOfficer}
                                            />
                                        )
                                    )}
                            </div>
                        </div>
                        <div className="border-end border-primary flex-fill">
                            <small className="text-muted p-1 fw-light">
                                Bonus Power
                            </small>
                            <div className="p-1 text-center">
                                {ship.power_all && (
                                    <span className="bonus-power">
                                        +{ship.power_all} All
                                    </span>
                                )}

                                {ship.power_weapons && (
                                    <span className="bonus-power">
                                        +{ship.power_weapons}
                                        <img
                                            height="16"
                                            src="/img/weapons-power.png"
                                            title="Weapon Power"
                                            alt="Weapon Power"
                                            className="mb-1"
                                        />
                                    </span>
                                )}

                                {ship.power_shields && (
                                    <span className="bonus-power">
                                        +{ship.power_shields}
                                        <img
                                            height="16"
                                            src="/img/shield-power.png"
                                            title="Shields Power"
                                            alt="Shields Power"
                                            className="mb-1"
                                        />
                                    </span>
                                )}

                                {ship.power_engines && (
                                    <span className="bonus-power">
                                        +{ship.power_engines}
                                        <img
                                            height="16"
                                            src="/img/engine-power.png"
                                            title="Engine Power"
                                            alt="Engines Power"
                                            className="mb-1"
                                        />
                                    </span>
                                )}

                                {ship.power_auxiliary && (
                                    <span className="bonus-power">
                                        +{ship.power_auxiliary}
                                        <img
                                            height="16"
                                            src="/img/auxiliary-power.png"
                                            title="Auxiliary Power"
                                            alt="Auxiliary Power"
                                            className="mb-1"
                                        />
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="flex-fill">
                            <small className="text-muted p-1 fw-light">
                                {ship.traits && ship.traits.length > 1 ? 'Traits' : 'Trait'}
                            </small>
                            <div className="p-1 text-center trait-list">
                                {ship.traits &&
                                    ship.traits.map((trait) => (
                                        <a
                                            href={
                                                "https://stowiki.net/wiki/" +
                                                trait.url
                                            }
                                            target="_blank"
                                            key={trait.id}
                                            rel="noreferrer"
                                        >
                                            <img
                                                style={{
                                                    height: "30px",
                                                    borderRadius: "2px",
                                                    fontSize: 0,
                                                    minHeight: "22px"
                                                }}
                                                src={
                                                    "https://stowiki.net/wiki/Special:Redirect/file/" +
                                                    trait.img_url
                                                }
                                                alt={trait.name}
                                                title={trait.name}
                                            />
                                        </a>
                                    ))}
                            </div>
                        </div>
                    </div>
                    <div className="row g-0 border-top border-primary align-middle">
                        <div className="col p-1 text-center border-end border-primary">
                            {ship.eng_consoles}
                            <img
                                className="mb-1 me-1"
                                src="/img/Console_eng_icon.png"
                                alt="Engineering Consoles"
                            />

                            {ship.tac_consoles}
                            <img
                                className="mb-1 me-1"
                                src="/img/Console_tac_icon.png"
                                alt="Tactical Consoles"
                            />

                            {ship.sci_consoles}
                            <img
                                className="mb-1 me-1"
                                src="/img/Console_sci_icon.png"
                                alt="Science Consoles"
                            />
                        </div>
                        <div className="col text-center p-1">
                            {ship.eng_admirality && (
                                <>
                                    {ship.eng_admirality}
                                    <img
                                        className="mb-1 me-1"
                                        src="/img/Adm_eng_fed.png"
                                        alt="Engineering Admirality Stat"
                                    />
                                </>
                            )}

                            {ship.tac_admirality && (
                                <>
                                    {ship.tac_admirality}
                                    <img
                                        className="mb-1 me-1"
                                        src="/img/Adm_tac_fed.png"
                                        alt="Tactical Admirality Stat"
                                    />
                                </>
                            )}

                            {ship.sci_admirality && (
                                <>
                                    {ship.sci_admirality}
                                    <img
                                        className="mb-1 me-1"
                                        src="/img/Adm_sci_fed.png"
                                        alt="Science Admirality Stat"
                                    />
                                </>
                            )}
                        </div>
                    </div>
                    {ship.admirality_ability && (
                        <div className="row g-0 border-top border-primary">
                            <div className="d-offset-4 border-primary col text-center p-1">
                                {ship.admirality_ability}
                            </div>
                        </div>
                    )}
                </div>
                <div className="card-footer">
                    {ship.prices && (
                        <span className="btn-group btn-group-sm btn-outline-primary border-secondary">
                            {ship.prices.map((price) => (
                                <Price key={price.id} price={price} />
                            ))}
                        </span>
                    )}

                    <button
                        className={`btn btn-sm border-primary text-white float-end ${
                            isPinned ? "btn-secondary" : "btn-primary"
                        }`}
                        aria-pressed={isPinned}
                        onClick={(e) => togglePinned(ship.id)}
                    >
                        {isPinned ? <PinAngleFill /> : <Pin />}
                    </button>

                    <a
                        className="btn btn-info btn-sm float-end me-1"
                        href={"https://stowiki.net/wiki/" + ship.wiki_url}
                        target="_blank"
                        rel="noreferrer"
                    >
                        STOwiki
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Ship;
